import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcessoNegadoComponent } from './acesso-negado/acesso-negado.component';
import { AppComponent } from './app.component';
import{NovoRegistroComponent} from './novo-registro/novo-registro.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { RenovarRegistroComponent } from './renovar-registro/renovar-registro.component';
import { RegistroSucessoComponent } from './sucesso/registro-sucesso.component';
import { AcessoComRegistroComponent } from './acesso-com-registro/acesso-com-registro.component';

const routes: Routes = [
  // {path: '', component: AppComponent},
  // {path: 'home', component: AppComponent},
  {path: 'registrar', component: NovoRegistroComponent},
  {path: 'registrar/:CertificadoCaepf/:inscricao', component: NovoRegistroComponent},
  {path: 'renovar', component: RenovarRegistroComponent},
  {path: 'sucesso/:contrato/:restrito/:funcionalidade/:perfil', component: RegistroSucessoComponent},
  {path: 'acesso-negado', component: AcessoNegadoComponent},
  {path: 'acesso-com-registro', component: AcessoComRegistroComponent},
  { path: '**', component: PaginaNaoEncontradaComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { 
}

export const routingComponents = [
  NovoRegistroComponent, 
  RenovarRegistroComponent,
  AcessoNegadoComponent
]